import React, { useEffect, useRef } from 'react';
import styles from './view-item-video.module.scss';

export const ViewItemVideo = ({
    className,
    autoPlay,
    playsInline,
    controls,
    loop,
    muted,
    image,
    isInView
}) => {
    const { normal, video } = image;

    const videoRef = useRef(null);

    useEffect(() => {
        const video = videoRef.current;
        if (isInView) {
            video.play();
        } else {
            video.pause();
        }
    }, [isInView]);

    return (
        <video
            ref={videoRef}
            className={`${styles.viewItemVideo} ${className}`}
            autoPlay={autoPlay}
            playsInline={playsInline}
            muted={muted}
            loop={loop}
            controls={controls}
            poster={normal}>
            <source type="video/mp4" src={video} />
        </video>
    );
};

ViewItemVideo.defaultProps = {
    className: '',
    autoPlay: true,
    playsInline: true,
    muted: true,
    loop: true,
    controls: false
};
